<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from '../general/empty-state-block.vue'

export default {
  name: 'ClientGroupOverviewFailureBlock',
  components: { EmptyStateBlock },
  mixins: [baseMixin],
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  computed: {
    compErrorMessage() {
      if (!this.error?.message)
        return this.$t('clientGroupOverview.error.noMessageFromServer')
      return this.error?.message
    },
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    retry() {
      this.$emit('retry')
    },
  },
}
</script>

<template>
  <EmptyStateBlock :description="compErrorMessage" border>
    <template v-slot:title>
      <h2 class="mb-4">
        {{ $t('clientGroupOverview.error.unableToLoadTitle') }}
      </h2>
    </template>
    <template v-slot:button>
      <div class="mt-4">
        <v-btn
          data-testid="client-group-overview-failure-block-back-btn"
          class="mr-2"
          outlined
          text
          large
          @click="goBack"
        >
          {{ $t('general.backBtnText') }}
        </v-btn>

        <v-btn
          data-testid="client-group-overview-failure-block-retry-btn"
          class="mr-2"
          color="primary"
          depressed
          large
          @click="retry"
        >
          <v-icon left>mdi-refresh</v-icon>{{ $t('general.retryBtnText') }}
        </v-btn>
      </div>
    </template>
  </EmptyStateBlock>
</template>
